<div class="space-y-8">

  <!-- Header -->
  <div>
    <h1 class="text-2xl font-semibold text-slate-900 mb-2" translate>examination-ai.step5.title</h1>
  </div>

  <!-- Chargement initial -->
  @if (loading() && verificationStatus() === 'pending' && !modalOpen()) {
  <div class="flex items-center justify-center py-8">
    <mat-spinner [diameter]="32"></mat-spinner>
    <span class="ml-3 text-slate-600" translate>examination-ai.step5.loading</span>
  </div>
  }

  <!-- ── Intro content — visible uniquement en pending ── -->
  @if (verificationStatus() === 'pending' && !loading() && !modalOpen()) {

  <!-- Recommandation mobile -->
  <div class="bg-blue-50 border border-blue-200 rounded-xl p-4 flex items-start gap-3">
    <mat-icon class="icon-size-5 text-blue-600 flex-shrink-0 mt-0.5">smartphone</mat-icon>
    <p class="text-blue-800" [innerHTML]="'examination-ai.step4b.mobile-advice' | translate">
    </p>
  </div>

  <!-- Comment ça se passe -->
  <div class="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-3">
    <div class="flex items-center gap-2 mb-1">
      <mat-icon class="icon-size-5 text-slate-600">list_alt</mat-icon>
      <span class="font-semibold text-slate-700" translate>examination-ai.step4b.how-it-works</span>
    </div>
    <ol class="space-y-2">
      <li class="flex items-start gap-2 text-[14px] text-slate-700">
        <mat-icon class="icon-size-4 text-amber-600 flex-shrink-0 mt-0.5">badge</mat-icon>
        <span [innerHTML]="'examination-ai.step4b.step-doc' | translate"></span>
      </li>
      <li class="flex items-start gap-2 text-[14px] text-slate-700">
        <span class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-600 text-white text-[11px] flex items-center justify-center font-bold mt-0.5">1</span>
        <span translate>examination-ai.step4b.step1</span>
      </li>
      <li class="flex items-start gap-2 text-[14px] text-slate-700">
        <span class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-600 text-white text-[11px] flex items-center justify-center font-bold mt-0.5">2</span>
        <span translate>examination-ai.step4b.step2</span>
      </li>
      <li class="flex items-start gap-2 text-[14px] text-slate-700">
        <span class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-600 text-white text-[11px] flex items-center justify-center font-bold mt-0.5">3</span>
        <span translate>examination-ai.step4b.step3</span>
      </li>
      <li class="flex items-start gap-2 text-[14px] text-slate-700">
        <span class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-600 text-white text-[11px] flex items-center justify-center font-bold mt-0.5">4</span>
        <span translate>examination-ai.step4b.step4</span>
      </li>
    </ol>
  </div>

  <!-- Sécurité -->
  <div class="bg-green-50 border border-green-200 rounded-xl p-4 flex items-start gap-3">
    <mat-icon class="icon-size-5 text-green-600 flex-shrink-0 mt-0.5">lock</mat-icon>
    <p class="text-green-800 text-[14px]">
      {{ 'examination-ai.step4b.security' | translate }}
      <a href="https://stripe.com/fr/privacy" target="_blank" rel="noopener"
         class="text-green-700 underline hover:text-green-900 ml-1">{{ 'examination-ai.step4b.privacy-link' | translate }}</a>.
    </p>
  </div>
  }

  <!-- Bloc modal ouverte -->
  @if (modalOpen()) {
  <div class="p-5 bg-blue-50 border border-blue-200 rounded-xl">
    <div class="flex items-center gap-3">
      <mat-spinner [diameter]="24"></mat-spinner>
      <div>
        <p class="text-sm font-medium text-blue-900" translate>examination-ai.step5.modal-in-progress</p>
        <p class="text-sm text-blue-700" translate>
          examination-ai.step5.modal-message
        </p>
      </div>
    </div>
  </div>
  }

  @switch (verificationStatus()) {

  @case ('processing') {
    @if (isBlocked) {
    <div class="p-4 bg-red-50 border border-red-200 rounded-lg space-y-2">
      <div class="flex items-center gap-2">
        <mat-icon class="text-red-600">error</mat-icon>
        <p class="text-sm font-medium text-red-900" translate>examination-ai.step5.status.definitively-failed</p>
      </div>
      <p class="text-sm text-red-700 font-medium" [innerHTML]="'examination-ai.step5.status.definitively-failed-message' | translate:{current: attemptsCount(), max: 2}">
      </p>
      <p class="text-sm text-red-800 mt-2">
        Veuillez contacter le support pour débloquer votre vérification :
        <a class="underline text-blue-700 hover:text-blue-900 ml-1" href="mailto:flashlevel@lingueo.com">flashlevel&#64;lingueo.com</a>.
      </p>
    </div>
    } @else {
    <div class="p-4 bg-orange-50 border border-orange-200 rounded-lg">
      <div class="flex items-center gap-3">
        <mat-spinner [diameter]="20"></mat-spinner>
        <p class="text-sm text-orange-800 font-medium" translate>examination-ai.step5.status.processing</p>
      </div>
      <p class="text-sm text-orange-700 mt-2" translate>
        examination-ai.step5.status.processing-note
      </p>
    </div>
    }
  }

  @case ('verified') {
  <div class="p-4 bg-green-50 border border-green-200 rounded-lg">
    <div class="flex items-center gap-2">
      <mat-icon class="text-green-600">check_circle</mat-icon>
      <p class="text-sm font-medium text-green-900" translate>examination-ai.step5.status.verified</p>
    </div>
  </div>
  <div class="flex justify-center">
    <button mat-flat-button color="primary" (click)="handleContinue()" class="px-8">
      <span class="flex items-center gap-2">
        <span translate>Valider</span>
      </span>
    </button>
  </div>
  }

  @case ('requires_input') {
  <div class="p-4 bg-orange-50 border border-orange-200 rounded-lg space-y-2">
    <div class="flex items-center gap-2">
      <mat-icon class="text-orange-600">rate_review</mat-icon>
      <p class="text-sm font-medium text-orange-900" translate>examination-ai.step5.status.requires-input</p>
    </div>
    <p class="text-sm text-orange-700" translate>
      examination-ai.step5.status.requires-input-message
    </p>
    <p class="text-sm text-orange-600" [innerHTML]="'examination-ai.step5.status.attempt-count' | translate:{current: attemptsCount(), max: 2}"></p>
  </div>
  }

  @case ('failed') {
  <div class="p-4 bg-orange-50 border border-orange-200 rounded-lg space-y-2">
    <div class="flex items-center gap-2">
      <mat-icon class="text-orange-600">warning</mat-icon>
      <p class="text-sm font-medium text-orange-900" translate>examination-ai.step5.status.failed</p>
    </div>
    @if (failureReason()) {
    <p class="text-sm text-orange-700" [innerHTML]="'examination-ai.step5.status.failed-reason' | translate:{reason: failureReason()}"></p>
    }
    <p class="text-sm text-orange-700" [innerHTML]="'examination-ai.step5.status.attempt-count' | translate:{current: attemptsCount(), max: 2}"></p>
    @if (canRetry) {
    <p class="text-sm text-orange-700" translate>examination-ai.step5.status.can-retry</p>
    }
  </div>
  }

  @case ('expired') {
    @if (isBlocked) {
    <div class="p-4 bg-red-50 border border-red-200 rounded-lg space-y-2">
      <div class="flex items-center gap-2">
        <mat-icon class="text-red-600">error</mat-icon>
        <p class="text-sm font-medium text-red-900" translate>examination-ai.step5.status.definitively-failed</p>
      </div>
      <p class="text-sm text-red-700 font-medium" [innerHTML]="'examination-ai.step5.status.definitively-failed-message' | translate:{current: attemptsCount(), max: 2}">
      </p>
      <p class="text-sm text-red-800 mt-2">
        Veuillez contacter le support pour débloquer votre vérification :
        <a class="underline text-blue-700 hover:text-blue-900 ml-1" href="mailto:flashlevel@lingueo.com">flashlevel&#64;lingueo.com</a>.
      </p>
    </div>
    } @else {
    <div class="p-4 bg-amber-50 border border-amber-200 rounded-lg space-y-2">
      <div class="flex items-center gap-2">
        <mat-icon class="text-amber-600">schedule</mat-icon>
        <p class="text-sm font-medium text-amber-900" translate>examination-ai.step5.status.expired</p>
      </div>
      <p class="text-sm text-amber-700" translate>
        examination-ai.step5.status.expired-message
      </p>
      <p class="text-sm text-amber-700" [innerHTML]="'examination-ai.step5.status.attempt-count' | translate:{current: attemptsCount(), max: 2}"></p>
    </div>
    }
  }

  @case ('definitively_failed') {
  <div class="p-4 bg-red-50 border border-red-200 rounded-lg space-y-2">
    <div class="flex items-center gap-2">
      <mat-icon class="text-red-600">error</mat-icon>
      <p class="text-sm font-medium text-red-900" translate>examination-ai.step5.status.definitively-failed</p>
    </div>
    @if (failureReason()) {
    <p class="text-sm text-red-700" [innerHTML]="'examination-ai.step5.status.failed-reason' | translate:{reason: failureReason()}"></p>
    }
    <p class="text-sm text-red-700 font-medium" [innerHTML]="'examination-ai.step5.status.definitively-failed-message' | translate:{current: 2, max: 2}">
    </p>
    <p class="text-sm text-red-800 mt-2">
      Veuillez contacter le support pour débloquer votre vérification :
      <a class="underline text-blue-700 hover:text-blue-900 ml-1" href="mailto:flashlevel@lingueo.com">flashlevel&#64;lingueo.com</a>.
    </p>
  </div>
  }

  @default {

  }
  }

  <!-- Erreur technique -->
  @if (errorMessage()) {
  <div class="p-4 bg-red-50 border border-red-200 rounded-lg">
    <div class="flex items-center gap-2">
      <mat-icon class="text-red-500 icon-size-4 flex-shrink-0">error_outline</mat-icon>
      <p class="text-sm text-red-800">{{ errorMessage() }}</p>
    </div>
  </div>
  }

  <!-- ── Boutons d'action ── -->

  @if (verificationStatus() === 'pending') {
  <div class="flex justify-center">
    <button mat-flat-button color="primary" (click)="startVerification()" [disabled]="loading()" class="px-8">
      @if (!loading()) {
      <span class="flex items-center gap-2">
        <mat-icon>verified_user</mat-icon>
        <span translate>examination-ai.step5.action.start</span>
      </span>
      } @else {
      <span class="flex items-center gap-2">
        <mat-spinner [diameter]="20" [strokeWidth]="3"></mat-spinner>
        <span translate>examination-ai.step5.action.opening</span>
      </span>
      }
    </button>
  </div>
  }

  @if (canResume) {
  <div class="flex justify-center">
    <button mat-flat-button color="primary" (click)="resumeVerification()" [disabled]="loading()" class="px-8">
      <span class="flex items-center gap-2">
        <mat-icon>play_arrow</mat-icon>
        <span translate>examination-ai.step5.action.resume</span>
      </span>
    </button>
  </div>
  }

  @if (canRetry) {
  <div class="flex justify-center">
    <button mat-flat-button color="primary" (click)="retryVerification()" [disabled]="loading()" class="px-8">
      @if (!loading()) {
      <span class="flex items-center gap-2">
        <mat-icon>replay</mat-icon>
        <span [innerHTML]="'examination-ai.step5.action.retry' | translate:{remaining: 2 - attemptsCount(), plural: (2 - attemptsCount()) > 1 ? 's' : ''}"></span>
      </span>
      } @else {
      <span class="flex items-center gap-2">
        <mat-spinner [diameter]="20" [strokeWidth]="3"></mat-spinner>
        <span translate>examination-ai.step5.action.opening</span>
      </span>
      }
    </button>
  </div>
  }

  @if (isBlocked) {
  <div class="flex justify-center">
    <button mat-stroked-button disabled class="px-8">
      <span class="flex items-center gap-2">
        <mat-icon>block</mat-icon>
        <span translate>examination-ai.step5.action.blocked</span>
      </span>
    </button>
  </div>
  }

</div>
